// Initialize account drawer functionality when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
  const accountDrawer = document.querySelector('#account-drawer');
  
  if (accountDrawer) {
    const tabs = accountDrawer.querySelectorAll('.account-drawer__tab');
    const forms = accountDrawer.querySelectorAll('.account-drawer__form');
    const forgotPasswordLink = accountDrawer.querySelector('.account-form__forgot-link');
    const closeButton = accountDrawer.querySelector('.account-drawer__close-btn');

    // Tab switching functionality
    function switchTab(targetTab) {
      // Remove active class from all tabs and forms
      tabs.forEach(tab => {
        tab.classList.remove('account-drawer__tab--active');
      });
      
      forms.forEach(form => {
        form.classList.remove('account-drawer__form--active');
      });

      // Handle tab visibility
      const loginTab = accountDrawer.querySelector('[data-tab="login"]');
      const registerTab = accountDrawer.querySelector('[data-tab="register"]');

      if (targetTab === 'register') {
        // Show register tab, hide login tab
        if (loginTab) loginTab.style.display = 'none';
        if (registerTab) {
          registerTab.style.display = 'block';
          registerTab.classList.add('account-drawer__tab--visible');
        }
      } else {
        // Show login tab, hide register tab
        if (loginTab) loginTab.style.display = 'block';
        if (registerTab) {
          registerTab.style.display = 'none';
          registerTab.classList.remove('account-drawer__tab--visible');
        }
      }

      // Add active class to selected tab and form
      const activeTab = accountDrawer.querySelector(`[data-tab="${targetTab}"]`);
      const activeForm = accountDrawer.querySelector(`#${targetTab}-form`);

      if (activeTab) {
        activeTab.classList.add('account-drawer__tab--active');
      }

      if (activeForm) {
        activeForm.classList.add('account-drawer__form--active');
      }

      // Clear any existing errors when switching tabs
      const errorElements = accountDrawer.querySelectorAll('.account-form__errors');
      errorElements.forEach(error => {
        error.style.display = 'none';
      });
    }

    // Close drawer functionality
    function closeDrawer() {
      const drawer = document.querySelector('custom-drawer');
      if (drawer) {
        drawer.closeModal();
      }
    }

    // Setup event listeners
    // Tab switching
    tabs.forEach(tab => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        const targetTab = tab.getAttribute('data-tab');
        switchTab(targetTab);
      });
    });

    // Close button
    if (closeButton) {
      closeButton.addEventListener('click', (e) => {
        e.preventDefault();
        closeDrawer();
      });
    }

    // Forgot password link
    if (forgotPasswordLink) {
      forgotPasswordLink.addEventListener('click', (e) => {
        e.preventDefault();
        // You can implement password recovery functionality here
        console.log('Forgot password clicked');
      });
    }

    // Create account button
    const createAccountButton = accountDrawer.querySelector('.account-form__create-account');
    if (createAccountButton) {
      createAccountButton.addEventListener('click', (e) => {
        e.preventDefault();
        const targetTab = createAccountButton.getAttribute('data-tab');
        switchTab(targetTab);
      });
    }

    // Sign in link in register form
    const signInLink = accountDrawer.querySelector('.account-form__signin-link-text');
    if (signInLink) {
      signInLink.addEventListener('click', (e) => {
        e.preventDefault();
        const targetTab = signInLink.getAttribute('data-tab');
        switchTab(targetTab);
      });
    }

    // Form submissions
    const loginForm = accountDrawer.querySelector('#login-form form');
    const registerForm = accountDrawer.querySelector('#register-form form');

    if (loginForm) {
      loginForm.addEventListener('submit', (e) => {
        handleFormSubmission(e, 'login');
      });
    }

    if (registerForm) {
      registerForm.addEventListener('submit', (e) => {
        handleFormSubmission(e, 'register');
      });
    }

    // Form submission handling
    function handleFormSubmission(event, formType) {
      // Clear any existing errors
      const errorElements = accountDrawer.querySelectorAll('.account-form__errors');
      errorElements.forEach(error => {
        error.style.display = 'none';
      });

      // Basic form validation
      const form = event.target;
      const inputs = form.querySelectorAll('input[required]');
      let isValid = true;

      inputs.forEach(input => {
        if (!input.value.trim()) {
          isValid = false;
          input.style.borderColor = '#dc3545';
        } else {
          input.style.borderColor = '#ddd';
        }
      });

      if (!isValid) {
        event.preventDefault();
        showError('Please fill in all required fields.');
        return;
      }

      // Email validation
      const emailInput = form.querySelector('input[type="email"]');
      if (emailInput && !isValidEmail(emailInput.value)) {
        event.preventDefault();
        showError('Please enter a valid email address.');
        return;
      }
    }

    function isValidEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    }

    function showError(message) {
      // Find the active form and show error
      const activeForm = accountDrawer.querySelector('.account-drawer__form--active');
      if (activeForm) {
        let errorElement = activeForm.querySelector('.account-form__errors');
        
        if (!errorElement) {
          errorElement = document.createElement('div');
          errorElement.className = 'account-form__errors';
          activeForm.insertBefore(errorElement, activeForm.firstChild);
        }
        
        errorElement.innerHTML = `<p>${message}</p>`;
        errorElement.style.display = 'block';
      }
    }
  }
});
